
import { Component, Input, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@commonNodeModules/@ngx-translate/core';
import { ConfirmDialogService } from '@commonServices/confirm-dialog.service';
import { ITitleLinkWrapper } from '@interfaces/iTile';

@Component({
	selector: 'app-link-tile',
	templateUrl: './link-tile.component.html',
	styleUrls: ['./link-tile.component.scss'],
	imports: [RouterLink, TranslatePipe]
})
export class LinkTileComponent implements OnInit {
	@Input() link: ITitleLinkWrapper;
	constructor(
		private confirmDialogService: ConfirmDialogService
	) { }

	ngOnInit(): void {
	}

	public click($event) {
		if (this.link.restricted) {
			this.confirmDialogService.open({
				title: this.link.restricted.title,
				confirm: this.link.restricted.confirm,
				description: this.link.restricted.description,
				reject: this.link.restricted.reject
			}, () => { window.open(this.link.restricted.url, '_blank').focus(); }, undefined);
		}
	}

}
